<script>
import { mapGetters, mapActions } from 'vuex'

import mapStoreValue from '@/util/mapStoreValue'

export default {

  computed: {

    ...mapGetters([
      'currentLevelId',
      'currentLevelName',
      'playerDirection',
      'connectedPlayerNodes'
    ]),

    playerCameraIsActive: mapStoreValue('playerCameraIsActive', 'setPlayerCameraIsActive')

  },

  methods: {

    ...mapActions([
      'rotateCamera',
      'moveCursorToNodeId',
      'movePlayerToCursor'
    ])

  }

}
</script>

<template>
  <div class="c-main-controls">
    <div class="c-main-controls-content">

      <router-link
        :to="{
          name: 'mainMenu'
        }"
        class="c-main-controls-item"
      >
        ⬅
      </router-link>

      <label
        class="c-main-controls-item"
      >
        <input
          v-model="playerCameraIsActive"
          type="checkbox"
        >

        Player cam
      </label>



      <button
        class="c-main-controls-item"
        @click="rotateCamera"
      >
        Rotate
      </button>



      <button
        class="c-main-controls-item"
        @click="movePlayerToCursor"
      >
        Move
      </button>

      <button
        v-for="{ id } in connectedPlayerNodes"
        :key="id"
        class="c-main-controls-item"
        @click="moveCursorToNodeId(id)"
      >
        {{ id }}
      </button>

    </div>
  </div>
</template>

<style lang="scss">

.c-main-controls {
  @include small-font;
  @include uppercase;
}

.c-main-controls-content {
  @include flex;
  @include flex-center;
}

.c-main-controls-item {
  @include flex;
  @include flex-center;

  @include radius;
  @include pad-tight;
  @include inline-block;
  background-color: translucent($black, 0.8);

  &:hover {
    background-color: translucent(#333, 0.8);
  }

  + .c-main-controls-item {
    margin-left: 0.5em;
  }

}

</style>
